<template>
  <div id="app">
    <div id="nav">
      <router-link :to="{ name: ROUTE_NEW_GAME }">New Game</router-link> |
      <a href="https://www.buymeacoffee.com/zechdc" target="_blank">Buy Me A Coffee</a> |
      <a href="https://trello.com/b/XJjclbej/acquiregameio-product-roadmap" target="_blank">Report a Bug/Suggest Features</a>
    </div>
    <router-view/>
    <o-toast />
  </div>
</template>

<script>
import {
  ROUTE_HOME,
  ROUTE_NEW_GAME,
} from "./router/constants";
import OToast from "@/components/layer/OToast";

export default {
  name: 'App',
  components: {OToast},
  data() {
    return {
      ROUTE_HOME,
      ROUTE_NEW_GAME,
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 10px;
  /*text-align: left;*/
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
